import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProvisioningService } from '../../../services/provisioning/provisioning.service';
import { ToastService } from '../../../services/toast/toast.service';
import { LoaderComponent } from '../../../atoms/loader/loader.component';

// cancel a requisition with a reason code + description. data = { bookingId }.
@Component({
  selector: 'app-cancel-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, LoaderComponent],
  templateUrl: './cancel-dialog.component.html',
  styleUrls: ['./cancel-dialog.component.scss', '../../../../common-style/dropdown.scss', '../../../../common-style/ac-dialog.scss'],
})
export class CancelDialogComponent implements OnInit {
  form: FormGroup;
  reasons: any[] = [];
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<CancelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { bookingId: number },
    private provisioningService: ProvisioningService,
    private toastService: ToastService
  ) {
    this.form = this.fb.group({
      cancelCode: ['', Validators.required],
      cancelDesc: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.provisioningService.getCancelReasons().subscribe({
      next: (res: any) => (this.reasons = res?.data || []),
      error: (err) => this.toastService.error(err?.error?.message || 'Failed to load reasons.'),
    });
  }

  submit(): void {
    if (this.form.invalid) {
      this.toastService.error('Select a reason and enter a description.');
      return;
    }
    this.isLoading = true;
    this.provisioningService.cancel(this.data.bookingId, this.form.value).subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Requisition cancelled.');
        this.isLoading = false;
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Cancellation failed.');
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
